import React from 'react'

import DynamicModuleLoaderComponent from '../sharedLegacy/components/DynamicModuleLoaderComponent/DynamicModuleLoaderComponent'
import webinarModule from '../Webinar'
import { WebinarContainerComponent } from '../Webinar/components'
import { WebinarAppStateProvider } from '../Webinar/providers/WebinarAppStateProvider'

const modules = [webinarModule]

const WebinarProducerRoutesComponent = () => {
  return (
    <DynamicModuleLoaderComponent modules={modules}>
      <WebinarAppStateProvider>
        <WebinarContainerComponent />
      </WebinarAppStateProvider>
    </DynamicModuleLoaderComponent>
  )
}

export { WebinarProducerRoutesComponent }
